export default __webpack_public_path__ + "static/media/Sad.09bcca1e.svg";